/**
 * 슬러그 생성 leaf 모듈.
 *
 * WHY: `place-slug.ts`는 `@/config/locations`를 import 하므로, locations.ts가
 * 슬러그 비교를 하려면 거기서 다시 place-slug.ts를 import 해야 해서 순환이 생긴다.
 * 순수 문자열 변환인 placeSlug만 의존성 없는 이 파일로 떼어내 양쪽이 안전하게 쓴다.
 */

/** Romanize an English name into a stable kebab-case slug. "New York" → "new-york". */
export function placeSlug(nameEn: string): string {
  return nameEn
    .trim()
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "") // strip diacritics
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
